import classNames from 'classnames';
import { JSX, ReactNode } from 'react';

import style from './index.module.css';

interface TopContentProps {
  children: ReactNode;
  noTopPadding?: boolean;
  noBottomPadding?: boolean;
  noLeftPadding?: boolean;
  noRightPadding?: boolean;
}

export default function HeroTopContent({
  children,
  noTopPadding,
  noBottomPadding,
  noLeftPadding,
  noRightPadding,
}: TopContentProps): JSX.Element {
  return (
    <div
      className={classNames({
        [style['TopContent']!]: true,
        [style['TopPadding']!]: !noTopPadding,
        [style['BottomPadding']!]: !noBottomPadding,
        [style['LeftPadding']!]: !noLeftPadding,
        [style['RightPadding']!]: !noRightPadding,
      })}
    >
      {children}
    </div>
  );
}
